import React from 'react';

import { Button, Modal } from '@/components';
import { Trans, useTranslation } from 'react-i18next';
import HornIcon from '../../../../../../public/assets/icons/horn.svg';
import ImageIcon from '../../../../../../public/assets/icons/image.svg';
import styles from './SubmitModal.module.css';

interface SubmitModalProps {
  type: string;
  companyName: string;
  onCancel: () => void;
}

function SubmitModal({ type, companyName, onCancel }: SubmitModalProps) {
  const { t } = useTranslation();

  return (
    <Modal closeButton={false} modalStyles={{ maxWidth: '480px' }}>
      <div className={styles.welcomeModal}>
        {type === 'BEAT_FINISHED' && <ImageIcon />}
        {type === 'COLLABORATION_FINISHED' && <HornIcon />}
        {type === 'BEAT_FINISHED' && (
          <h2 className={styles.welcomeModalTitle}>{t('screenshot.modal.beatTitle')}</h2>
        )}
        {type === 'COLLABORATION_FINISHED' && (
          <h2 className={styles.welcomeModalTitle}>
            <Trans
              i18nKey="screenshot.modal.collabTitle"
              components={{
                1: <span />
              }}
              values={{ company: companyName }}
            />
          </h2>
        )}
        <h2 className={styles.welcomeModalDescription}>
          {type === 'BEAT_FINISHED' && t('screenshot.modal.beatDescription')}
          {type === 'COLLABORATION_FINISHED' && t('screenshot.modal.collabDescription')}
        </h2>

        <div className={styles.welcomeModalButton}>
          <Button theme="cta" onClick={onCancel}>
            {type === 'BEAT_FINISHED' && t('screenshot.modal.beatButton')}
            {type === 'COLLABORATION_FINISHED' && t('actions.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default SubmitModal;
